import { State } from '../../types';

export const alaska: State = {
  name: 'Alaska',
  abbreviation: 'AK',
  terms: [
    {
      word: 'Alyeska',
      phonetic: 'al-lee-YES-ka',
      // audioUrl: '/audio/kenai.mp3',
      description: 'an Aleut word meaning "the great land'
    },
    {
      word: 'Eklutna',
      phonetic: 'ee-kloot-nuh',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A small native village 24 miles northeast of Anchorage.'
    },
    {
      word: 'Kasilof',
      phonetic: 'kuh-see-loff',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A census-designated place in Alaska. The name was given to the area by early Russian settlers.'
    },
    {
      word: 'Kenai',
      phonetic: 'KEE-nye',
      // audioUrl: '/audio/kenai.mp3',
      description: 'Peninsula and city in southern Alaska'
    },
    {
      word: 'Knik Glacier',
      phonetic: 'kuh-nick glacier',
      // audioUrl: '/audio/kenai.mp3',
      description: 'PA glacier near the northernmost part of Cook Inlet.'
    },
    {
      word: 'Koyukuk',
      phonetic: 'KOY-yuh-kuk',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A river and city in Alaska, often mispronounced as "KOY-uh-kuk."'
    },
    {
      word: 'Matanuska-Susitna',
      phonetic: 'mat-uh-NOO-skuh soo-SIT-na',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A small borough in Alaska.'
    },
    {
      word: 'Seward',
      phonetic: 'soo-ward',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A city in the Kenai Peninsula Borough.'
    },
    {
      word: 'Tanana',
      phonetic: 'TAN-uh-naw',
      // audioUrl: '/audio/kenai.mp3',
      description: 'A city and river in Alaska, commonly mispronounced as "TAN-uh-nuh."'
    },
    {
      word: 'Valdez',
      phonetic: 'val-DEEZ',
      // audioUrl: '/audio/valdez.mp3',
      description: 'Coastal city in southern Alaska'
    }
  ]
};